<div
  *transloco="let t; scope: 'uiComponents'; prefix: 'uiComponents.feedback'"
  class="bd-feedback-form"
  data-id="assistant-feedback-form"
>
  @if (interactive()) {
    <fieldset
      class="bd-feedback-form-rating-picker"
      data-id="assistant-feedback-rating-picker"
    >
      <legend class="bd-label-regular">{{ t('starPromptTitle') }}</legend>
      <div class="bd-feedback-form-rating-stars">
        @for (state of starStates(); track state.value) {
          <label
            class="bd-feedback-rating-star"
            [class.bd-feedback-rating-star--filled]="state.filled"
            [attr.data-id]="'assistant-feedback-star-' + state.value"
          >
            <input
              type="radio"
              class="bd-feedback-rating-star-input"
              name="assistant-feedback-rating"
              [value]="state.value"
              [checked]="state.selected"
              [attr.aria-label]="t('starAriaLabel', { value: state.value })"
              (change)="pickRating(state.value)"
            />
            <span aria-hidden="true">{{ state.filled ? '★' : '☆' }}</span>
          </label>
        }
      </div>
    </fieldset>
  }

  @if (!interactive() || hasRating()) {
    <span class="bd-label-regular" data-id="assistant-feedback-title">{{
      effectiveDirection() === 'up'
        ? t('feedbackTitlePositive')
        : t('feedbackTitle')
    }}</span>

    @if (availableCategories().length > 0) {
      <div
        class="bd-feedback-form-category-section"
        data-id="assistant-feedback-categories"
      >
        <span
          class="bd-label-small bd-feedback-form-category-hint"
          data-id="assistant-feedback-category-hint"
        >
          {{ t('categoryHint') }}
        </span>
        <div class="bd-feedback-form-category-chips">
          @for (chip of chipStates(); track chip.value) {
            <button
              type="button"
              class="bd-feedback-category-chip bd-body-regular"
              [class.bd-feedback-category-chip--selected]="chip.selected"
              [attr.aria-pressed]="chip.selected"
              [attr.data-id]="'assistant-feedback-chip-' + chip.value"
              (click)="toggleCategory(chip.value)"
            >
              {{ t(chip.labelKey) }}
            </button>
          }
        </div>
      </div>
    }

    <div class="bd-feedback-form-textarea-wrapper">
      <textarea
        id="assistant-feedback-textarea"
        pInputTextarea
        data-id="assistant-feedback-textarea"
        class="bd-feedback-form-textarea"
        rows="3"
        [maxlength]="maxLength"
        autoResize
        [placeholder]="t('feedbackCommentInputLabel')"
        [(ngModel)]="comment"
      ></textarea>
      <span
        class="bd-label-small bd-feedback-form-counter"
        data-id="assistant-feedback-counter"
      >
        {{ comment().length }}/{{ maxLength }}
      </span>
    </div>
  }
  <div class="bd-feedback-form-actions">
    @if (!interactive() || hasRating()) {
      @if (showSkip()) {
        <p-button
          styleClass="bd-size-small"
          [outlined]="true"
          data-id="assistant-feedback-skip-button"
          (onClick)="onSkip()"
          [label]="t('skipForNow')"
        ></p-button>
      } @else {
        <p-button
          styleClass="bd-size-small"
          [outlined]="true"
          data-id="assistant-feedback-dismiss-button"
          (onClick)="onDismiss()"
          [label]="t('dismiss')"
        ></p-button>
      }
    }
    <p-button
      styleClass="bd-size-small"
      data-id="assistant-feedback-submit-button"
      (onClick)="onSubmit()"
      [disabled]="!canSubmit()"
      [label]="t('submit')"
    ></p-button>
  </div>
</div>
